import { Box, Container, Heading, Link, Text, VStack } from "@chakra-ui/react";

import { useI18n } from "@/i18n";
import { PageShell } from "@/shared/layout/PageShell";
import { GlowButton } from "@/shared/ui/GlowButton";

export function SupportPage() {
  const { copy } = useI18n();

  return (
    <PageShell>
      <Box as="main" pt={{ base: 28, md: 32 }} pb={20}>
        <Container maxW="780px">
          <VStack align="start" spacing={7}>
            <Text color="nvp.cyan" fontWeight={900} textTransform="uppercase">
              NVP Games
            </Text>
            <Heading as="h1" fontSize={{ base: "3rem", md: "4.6rem" }}>
              {copy.support.title}
            </Heading>
            <Text color="whiteAlpha.800" fontSize="xl" lineHeight={1.7}>
              {copy.support.body}
            </Text>
            <GlowButton
              as={Link}
              href="mailto:support@nvpgames.com"
              glow="blue"
              _hover={{ textDecoration: "none", filter: "brightness(1.08)" }}
            >
              {copy.support.emailLabel}: support@nvpgames.com
            </GlowButton>
          </VStack>
        </Container>
      </Box>
    </PageShell>
  );
}
